import { detectEnvironment } from '@/shared/lib/detectEnvironment';

/**
 * Generates the saved-filters config endpoint URL.
 * For staging: /config/saved-filters_staging
 * For production/other: /config/saved-filters
 *
 * @param id - Optional saved filter id to append (targets a single filter). Omit to target the
 *   whole collection; passing an empty/whitespace-only id is treated as a caller bug rather than
 *   silently falling back to the collection endpoint, since that would turn a single-filter
 *   delete/save call into one that targets every saved filter.
 * @returns The full saved-filters endpoint URL
 */
export const getSavedFiltersApiUrl = (id?: string): string => {
  const basePath =
    detectEnvironment() === 'staging' ? '/config/saved-filters_staging' : '/config/saved-filters';

  if (id === undefined) {
    return basePath;
  }

  const trimmedId = id.trim();
  if (!trimmedId) {
    throw new Error('getSavedFiltersApiUrl: id must not be empty');
  }

  return `${basePath}/${trimmedId}`;
};
